import { render, staticRenderFns } from "./staffRemove.vue?vue&type=template&id=0d9c6c75&scoped=true&"
import script from "./staffRemove.vue?vue&type=script&lang=js&"
export * from "./staffRemove.vue?vue&type=script&lang=js&"
import style0 from "./staffRemove.vue?vue&type=style&index=0&id=0d9c6c75&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c6c75",
  null
  
)

export default component.exports